<script>
    import { alert, filterThoughtsByProject } from "../store";
    import {
        DataTable,
        Toolbar,
        ToolbarContent,
        OverflowMenu,
        OverflowMenuItem,
        Button,
        Modal,
        Form,
        FormGroup,
        TextInput,
        ToolbarBatchActions,
    } from "carbon-components-svelte";
    import TrashCan16 from "carbon-icons-svelte/lib/TrashCan16";
    import DocumentAdd20 from "carbon-icons-svelte/lib/DocumentAdd20";
    import {projects, Projectsvc} from "../services/project";

    let projectsvc = new Projectsvc();
    let selectedRowIds = [];
    let confirmDelete = false;
    let openprojectmodal = false;
    let newProjectName = "New project";
    let newProjectDescription;
    let updateProjectId;  
    let editprojectmodal;  
    

    function update() {
        try {
            for (var i = 0; i < $projects.length; i++) {
                if ($projects[i].id == updateProjectId) {
                    $projects[i].name = newProjectName
                    $projects[i].description = newProjectDescription
                    projectsvc.update([$projects[i]]);
                    break;
                }
            }
        } catch (e) {
            //alert(e.message);
            console.log("Error updating project");
            console.log(e);
            alert.update((n) => [...n, "Failed to update project " + e.message]);
            confirmDelete = false;
        }
        selectedRowIds = [];
        editprojectmodal = false;
    } 
    
    function remove() {
        try {
            let toBeDeleted = [];
            selectedRowIds.forEach((item) => {
                for (var i = 0; i < $projects.length; i++) {
                    if ($projects[i].id == item) {
                        $projects[i].status = 2
                        toBeDeleted.push($projects[i])
                    }
                }
            });
            projectsvc.update(toBeDeleted);
        } catch (e) {
            //alert(e.message);
            console.log("Error removing project");
            console.log(e);
            alert.update((n) => [...n, "Failed to remove project " + e.message]);
            confirmDelete = false;
        }
        selectedRowIds = [];
        confirmDelete = false;
    }
    function createProject() {
        const data = {
            name: newProjectName
        }
        try {
            projectsvc.add(data);
            console.log("Added project " + data.name);
        } catch (e) {
            //alert(e.message);
            console.log(e);
            alert.update((n) => [
                ...n,
                "Failed to add project " +
                    data.name +
                    " to project " +
                    e.message,
            ]);
        }
        console.log("createProject: reset");
        newProjectName = "";
        openprojectmodal = false;

}

</script>
{filterThoughtsByProject(1)}
<DataTable
    sortable
    selectable bind:selectedRowIds
    title="Projects"
    description="Overview of active projects:"
    headers={[
        { key: 'name', value: 'Name' }, 
        { key: 'description', value: 'Description' },
        { key: 'status', value: 'Status' },
        { key: 'priority', value: 'Priority' },
        { key: 'nextaction', value: 'NextAction'},
        { key: 'overflow'},
    ]}
    id="ProjectsTable"
    rows={$projects}
>
    <Toolbar>
        <ToolbarBatchActions>
            <Button icon={TrashCan16} on:click={() => (confirmDelete = true)}
                >Delete</Button
            >
        </ToolbarBatchActions>
        <ToolbarContent>
            <Button
                icon={DocumentAdd20}
                aria-label="Create Project"
                on:click={() => (openprojectmodal = true)}>Add Project</Button
            >
        </ToolbarContent>
    </Toolbar>
    <svelte:fragment slot="cell" let:cell let:row>
        {#if cell.key === "overflow"}
            <OverflowMenu flipped>
                <OverflowMenuItem 
                    text="Edit" 
                    id="edit"
                    on:click={() => {
                        updateProjectId = row.id;
                        newProjectName = row.name;
                        editprojectmodal = true;
                    }}
                />
                <OverflowMenuItem
                    danger
                    id="delete"
                    text="Delete"
                    on:click={() => {
                        selectedRowIds.push(row.id);
                        confirmDelete = true;
                    }}
                />
            </OverflowMenu>
        {:else}{cell.value}{/if}
    </svelte:fragment>
</DataTable>

<Modal
    bind:open={confirmDelete}
    modalHeading="Delete Project"
    primaryButtonText="Confirm"
    secondaryButtonText="Cancel"
    on:click:button--secondary={() => (confirmDelete = false)}
    on:open
    on:close
    on:submit={remove}
>
    <p>Delete these project(s).</p>
    <!-- For some reason this doesn't update in real time -->
    <ul>
        {#each $projects as row}
            {#each selectedRowIds as x}
                    {#if row.id == x}
                        <li>{row.name}</li>
                    {/if}
            {/each}
        {/each}
    </ul>
</Modal>

<Modal
    bind:open={openprojectmodal}
    modalHeading="Add Project"
    primaryButtonText="Submit"
    secondaryButtonText="Cancel"
    on:click:button--secondary={() => (openprojectmodal = false)}
    on:open
    on:close
    on:submit={createProject}
>
    <Form on:submit>
        <FormGroup legendText="Add a project">
            <TextInput
                id="projectInput"
                labelText="Project"
                bind:value={newProjectName}
            />
        </FormGroup>
    </Form>
</Modal>

<Modal
    bind:open={editprojectmodal}
    modalHeading="Edit Project"
    primaryButtonText="Submit"
    secondaryButtonText="Cancel"
    on:click:button--secondary={() => (editprojectmodal = false)}
    on:open
    on:close
    on:submit={update}
>
    <Form on:submit>
        <FormGroup legendText="Edit a project">
            <TextInput
                id="projectInput"
                labelText="Project"
                bind:value={newProjectName}
            />
            <TextInput
            id="projectdescriptionInput"
            labelText="Project Description"
            bind:value={newProjectDescription}
        />            
        </FormGroup>
    </Form>
</Modal>